//token.js
//utilities for storing OAuth token in Cookie

import storage from "../core/storage.js";

let TOKEN_NAME = "vivial_connect_token";
let TOKEN_EXPIRE_IN_MINUTES = 1;

const init = ({ config }) => {
  if (!config || typeof config.COOKIE !== "object") return;
  if (config.COOKIE.TOKEN_NAME) TOKEN_NAME = `__${btoa(config.TOKEN_NAME)}`;
  if (config.COOKIE.TOKEN_EXPIRE_IN_MINUTES)
    TOKEN_EXPIRE_IN_MINUTES = config.COOKIE.TOKEN_EXPIRE_IN_MINUTES;
};

const get = () => {
  return storage.getCookie(TOKEN_NAME);
};

const set = ({ access_token, expires_in }) => {
  const expirationTimeInMilliseconds = expires_in
    ? new Date().getTime() + expires_in * 1000
    : new Date().getTime() + TOKEN_EXPIRE_IN_MINUTES * 60 * 1000;

  const timezoneOffsetInMilliseconds =
    new Date().getTimezoneOffset() * 60 * 1000;

  const expiresIn = new Date(
    expirationTimeInMilliseconds - timezoneOffsetInMilliseconds
  );
  storage.setCookie(TOKEN_NAME, access_token, expiresIn);
};

const clear = () => {
  storage.removeCookie(TOKEN_NAME);
};

export default {
  init,
  get,
  set,
  clear,
};
